import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { FormControlLabel, Grid, Checkbox } from "@mui/material";

import { useAxios } from "../../../../hooks";
import { AutocompleteMultiSelect, TextField } from "../../../../components";

export default function AudienceName({
  state,
  dispatch,
  editState,
  formikProps,
  setFields,
  messages,
  disaptchMessage,
}) {
  const axios = useAxios();
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});
  const [contributors, setContributors] = useState([]);
  const { parentState } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (state["audience_group"]) {
      setInput((prev) => ({
        ...prev,
        audience_group: state["audience_group"],
      }));
    }

    if (state["contributorsChecked"]) {
      setInput((prev) => ({
        ...prev,
        contributorsChecked: true,
      }));
    }

    if (messages["audience_group"]) {
      setMessage({
        audience_group: messages["audience_group"],
      });
    }
  }, [state, messages]);

  useEffect(() => {
    if (formikProps?.values?.contributorsChecked) {
      axios({
        url: "/user/getAllDataPartner",
        method: "get",
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        let contributors = [];
        if (response.status) {
          for (let contributor of response.data.data) {
            if (contributor.connectionDetails.status === "ACTIVE") {
              contributors.push({
                id: contributor.connectionDetails.brand_id,
                name: contributor.brandDetails.brand_name,
              });
            }
          }
          setContributors(contributors);
        }
      });
    }
  }, [formikProps.values.contributorsChecked, axios]);

  useEffect(() => {
    if (formikProps.values?.contributors?.value?.length > 0) {
      axios({
        url:
          "/adtech/getAllDynamicFields?contributor_id=" +
          formikProps.values.contributors.value,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setFields(response.data);
        }
      });
    }
  }, [axios]);

  const handleFieldChange = (value, name, key) => {
    dispatch({
      type: "UPDATE_FIELD",
      formikProps: formikProps,
      payload: { value, name, key },
    });

    disaptchMessage({
      type: "MESSAGE_UPDATE",
      payload: { value: message, key: name },
    });
  };

  return (
    <Fragment>
      <Grid size={6}>
        <TextField
          required
          size="small"
          $isFilled={!!input?.audience_group?.value}
          label="Audience Name"
          name="audience_group.value"
          placeholder="Audience Name"
          disabled={!editState}
          value={input?.audience_group?.value}
          inputProps={{ maxLength: 35 }}
          onBlur={(e) => {
            handleFieldChange(
              input?.audience_group?.value,
              "audience_group",
              "value"
            );
          }}
          onChange={(e) => {
            if (e.target.value?.length < 3) {
              setMessage({
                audience_group: "Audience Group must be at least 3 characters",
              });
            } else {
              setMessage({});
            }
            setInput({ audience_group: { value: e.target.value } });
          }}
          error={message["audience_group"]}
          helperText={message["audience_group"]}
        />
      </Grid>
    </Fragment>
  );

  function handleDropDown(value, name, key) {
    dispatch({
      type: "MULTI_DROP_DOWN",
      payload: { value, name, key },
    });
  }

  function handleChange(arr, { option }, reason, name, displayName, options) {
    let objectName = name.substring(0, name.indexOf("."));

    setInput((prev) => ({
      ...prev,
      [objectName]: setValuesOfDropDown(input[objectName]?.value),
    }));

    function setValuesOfDropDown(val) {
      let values = val ? [...val] : [];

      if (reason === "removeOption") {
        let v = option.id;
        if (values.includes(v)) {
          values = [...values.filter((items) => items !== option.idcon)];
        } else {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      handleDropDown(values, "contributors", "value");
      axios({
        url: "/adtech/getAllDynamicFields?contributor_id=" + values?.join(","),
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setFields(response.data);
        }
      });

      val = {
        value: values,
      };

      return val;
    }
  }
}
